import {Component, Input} from '@angular/core';
import {NavigationService} from '../../../../../../../../services/navigation/navigation.service';
import {LokalizacjaUszkodzenia} from '../../../../../../../../model/uszkodzenia/lokalizacja-uszkodzenia';
import {PakTenantService} from '../../../../../../../../services/pak/pak-tenant.service';

@Component({
  selector: 'shared-lokalizacje-uszkodzen',
  templateUrl: 'lokalizacje-uszkodzen.component.html'
})
export class LokalizacjeUszkodzenComponent {

  constructor(public navigation: NavigationService, private pakTenantService: PakTenantService) {
  }

  @Input()
  idPrzedmiotu!: number

  @Input()
  typPrzedmiotu!: string

  @Input()
  obrazPrzedmiotu?: string

  @Input()
  lokalizacjeUszkodzen: LokalizacjaUszkodzenia[] = []

  wybierzLokalizacje(lokalizacjaUszkodzenia: string): void {
    switch (lokalizacjaUszkodzenia) {
      case LokalizacjaUszkodzenia.POMIESZCZENIA_DOM_JEDNORODZINNY.name:
        this.navigation.navigateWithExtras(['/procesUszkodzen/przedmiotUbezpieczenia/' + lokalizacjaUszkodzenia], {queryParams: {id: this.idPrzedmiotu, typ: this.typPrzedmiotu}})
        break;
      default:
        this.navigation.navigateWithExtras(['/procesUszkodzen/przedmiotUbezpieczenia/' + lokalizacjaUszkodzenia], {queryParams: {idPrzedmiotu: this.idPrzedmiotu}})
        break;
    }
  }

  // Wysłanie eventu po załadowaniu obrazu przedmiotu na ekranie powiązane
  // z wymaganą informacją dla PAK dotyczacą zmiany rozmiaru okna samoobsługi
  afterImageLoad(): void {
    this.pakTenantService.emitViewChangedEvent();
  }
}
